export function log(...args) {
  const input = [...args];
  if (input.length < 1) return;

  // eslint-disable-next-line no-console
  console.log(`[Angora] ${input.shift()}:`, ...input);
}
